// extracted by mini-css-extract-plugin
export default {"root":"UploadFilesModal_root__NrM5i","container":"UploadFilesModal_container__GzB9u"};